// @flow

import React from 'react';
import _ from 'lodash';
import { Tracking } from 'web-core/src/tracking';

import conf from 'client/conf';
import GLOBALS from 'client/constants/globals';
import SmsInput from 'client/components/form/smsInput';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import Translate from 'client/components/translate';
import TwoColLayout from 'client/components/grid/twoColLayout';
import { WEB_CLICK_APP_DOWNLOAD } from 'routes/join/constants/tracking';
import type { LocationType } from 'types/react-router.flow';

const { appStoreUrl, playStoreBetaUrl, playStoreUrl, testFlightUrl } = GLOBALS;

const TRANSLATE_PREFIX = 'partner.enterprise.download';

type Props = {
  location: LocationType,
};

class DownloadPage extends React.PureComponent<Props> {
  trackDownload = (platform: string, modality: string) => {
    Tracking.track(WEB_CLICK_APP_DOWNLOAD, { cta: platform, modality });
  };

  render() {
    const betaBuild = _.get(this.props.location, 'state.betaBuild', false);
    return (
      <StrideHeaderWrapper showPhone={false}>
        <div className="download-page pad-x">
          <TwoColLayout
            sectionClassName="margin"
            leftContent={
              <div className="large-flex-row right small-text-center">
                <div className="large-col-medium">
                  <h1 className="light margin">
                    <Translate path={`${TRANSLATE_PREFIX}.header`} />
                  </h1>
                  <div className="hide-for-small-only">
                    <h4>
                      <Translate path={`${TRANSLATE_PREFIX}.${betaBuild ? 'betaSubheader' : 'subheader'}`} />
                    </h4>
                    <p className="margin-bottom">
                      <Translate path={`${TRANSLATE_PREFIX}.desc`} />
                    </p>
                    {betaBuild ? null : <SmsInput source="enterprise-download" />}
                    <p className="margin-top">
                      <Translate path={`${TRANSLATE_PREFIX}.oepHelpText`} />
                    </p>
                    <p className="margin-top font-bold">
                      <Translate path={`${TRANSLATE_PREFIX}.oepHelpTextCta`} />
                    </p>
                    <div className="pad-y-2">
                      <a
                        href={
                          betaBuild
                            ? testFlightUrl
                            : `${appStoreUrl}?pt=117960916&ct=Enterprise%20Download%20Page&mt=8&ls=true`
                        }
                        target="_blank"
                        rel="noreferrer noopener"
                        onClick={() => this.trackDownload('android', 'desktop')}>
                        <img
                          className="store-badge"
                          src={`${conf.CONTENTFUL_SPACE_URL}${
                            betaBuild
                              ? '/xzMBEuRzoGWm84ugC8Uy2/f12da0f66326dfca791cc86aa5caba6f/Download_on_the_App_Store_Badge_US-UK_135x40.svg'
                              : '/2IaGVK5dBCmAcW8K2I4UWc/8676b471978be5c87da71cf1e7aba4e3/app-store-badge.svg'
                          }`}
                          alt="Download on the App Store" />
                      </a>
                      <a
                        className="margin-left"
                        href={betaBuild ? playStoreBetaUrl : playStoreUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        onClick={() => this.trackDownload('apple', 'desktop')}>
                        <img
                          className="store-badge"
                          src={`${conf.CONTENTFUL_SPACE_URL}${
                            betaBuild
                              ? '/6WqIynyGlTgqdzLPzofLrN/55cddf9d05dbb58415aee5ef3fdd0cd7/google-play-badge.svg'
                              : '/5VRCSdr9fOiMygk2M2GIIW/3c803b735870c49f46550d8d07fec895/play-store-badge.svg'
                          }`}
                          alt="Get it on Google Play" />
                      </a>
                    </div>
                    <p>
                      <Translate path={`${TRANSLATE_PREFIX}.help`} />
                    </p>
                  </div>
                </div>
              </div>
            }
            rightContent={
              <div className="large-flex-row left">
                <img
                  alt=""
                  className="hero-image"
                  src="https://images.ctfassets.net/heg7gyzix6dq/3jBwC65bRVqjupIwkJgRYY/0d0d7c2b0b62f1da9b58d03687dbf62d/deals-tap.png" />
                <div className="hide-for-medium text-center">
                  <h4>
                    <Translate path={`${TRANSLATE_PREFIX}.${betaBuild ? 'betaSubheader' : 'subheader'}`} />
                  </h4>
                  <p className="margin-bottom">
                    <Translate path={`${TRANSLATE_PREFIX}.desc`} />
                  </p>
                  <p className="margin-top">
                    <Translate path={`${TRANSLATE_PREFIX}.oepHelpText`} />
                  </p>
                  <p className="margin-top font-bold">
                    <Translate path={`${TRANSLATE_PREFIX}.oepHelpTextCta`} />
                  </p>
                  <div className="pad-y">
                    <a
                      href={
                        betaBuild
                          ? testFlightUrl
                          : `${appStoreUrl}?pt=117960916&ct=Enterprise%20Download%20Page&mt=8&ls=true`
                      }
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() => this.trackDownload('apple', 'mobile')}>
                      <img
                        className="store-badge"
                        src={`${conf.CONTENTFUL_SPACE_URL}/xzMBEuRzoGWm84ugC8Uy2/f12da0f66326dfca791cc86aa5caba6f/Download_on_the_App_Store_Badge_US-UK_135x40.svg`}
                        alt="Download on the App Store" />
                    </a>
                    <a
                      className="margin-left"
                      href={betaBuild ? playStoreBetaUrl : playStoreUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() => this.trackDownload('android', 'mobile')}>
                      <img
                        className="store-badge"
                        src={`${conf.CONTENTFUL_SPACE_URL}/6WqIynyGlTgqdzLPzofLrN/55cddf9d05dbb58415aee5ef3fdd0cd7/google-play-badge.svg`}
                        alt="Get it on Google Play" />
                    </a>
                  </div>
                  <p>
                    <Translate path={`${TRANSLATE_PREFIX}.help`} />
                  </p>
                </div>
              </div>
            } />
        </div>
      </StrideHeaderWrapper>
    );
  }
}

export default DownloadPage;
